import React from "react";
import { Clock, CheckCircle, XCircle, AlertCircle } from "lucide-react";
import {
  isPendingCompOffStatus,
  CompOffStatusCode,
  COMP_OFF_APPROVED_STATUSES,
  COMP_OFF_REJECTED_STATUSES,
  COMP_OFF_CANCELLED_STATUSES,
} from "./constants";

export const getWorkingPeriodLabel = (isFirstHalf: boolean, isSecondHalf: boolean) => {
  if (isFirstHalf && isSecondHalf) return "Full Day";
  if (isFirstHalf) return "First Half";
  if (isSecondHalf) return "Second Half";
  return "None";
};

export const COMP_OFF_STATUS_FILTER_OPTIONS = [
  { value: "all", label: "All" },
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
] as const;

export const getCompOffStatusIcon = (status: string) => {
  const statusCode = status as CompOffStatusCode;
  if (isPendingCompOffStatus(status)) {
    return React.createElement(Clock, { className: "w-4 h-4 text-yellow-500" });
  }
  if (COMP_OFF_APPROVED_STATUSES.includes(statusCode)) {
    return React.createElement(CheckCircle, { className: "w-4 h-4 text-green-500" });
  }
  if (COMP_OFF_REJECTED_STATUSES.includes(statusCode)) {
    return React.createElement(XCircle, { className: "w-4 h-4 text-red-500" });
  }
  if (COMP_OFF_CANCELLED_STATUSES.includes(statusCode)) {
    return React.createElement(AlertCircle, { className: "w-4 h-4 text-slate-500" });
  }
  return React.createElement(Clock, { className: "w-4 h-4 text-slate-400" });
};

